import type { ForecastingRow } from '@/api/forecasting';

const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as const;

export function normalizeYear(year: number): number {
  if (!Number.isFinite(year)) return 0;
  if (year < 100) return 2000 + year;
  return year;
}

export function parseRowMonthDate(row: ForecastingRow): Date | null {
  if (row.Month__Date_) {
    const raw = row.Month__Date_.trim();

    const dmy = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(raw);
    if (dmy) {
      const month = Number(dmy[2]);
      const year = Number(dmy[3]);
      if (month >= 1 && month <= 12 && year > 0) {
        return new Date(year, month - 1, 1);
      }
    }

    if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
      const [year, month, day] = raw.slice(0, 10).split('-').map(Number);
      if (month >= 1 && month <= 12 && year > 0) {
        return new Date(year, month - 1, day || 1);
      }
    }

    const mmmYyyy = /^([A-Za-z]{3})\s+(\d{2,4})$/.exec(raw);
    if (mmmYyyy) {
      const monthIdx = MONTH_SHORT.findIndex(
        (m) => m.toLowerCase() === mmmYyyy[1].slice(0, 3).toLowerCase()
      );
      if (monthIdx >= 0) {
        return new Date(normalizeYear(Number(mmmYyyy[2])), monthIdx, 1);
      }
    }
  }

  const m = Number(String(row.Month).replace(/,/g, ''));
  const y = normalizeYear(Number(String(row.Year).replace(/,/g, '')));
  if (m >= 1 && m <= 12 && y > 0) return new Date(y, m - 1, 1);
  return null;
}

export function monthKeyFromDate(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

/** A month as the dashboard names it everywhere, e.g. "Apr-26". */
export function formatMonthLabel(d: Date): string {
  return `${MONTH_SHORT[d.getMonth()]}-${String(d.getFullYear()).slice(-2)}`;
}

/** Month label on chart axes and drill headers. The same "Apr-26" as
 *  everywhere else: the old Looker-style "1 Apr 2026" read as a single day and
 *  crowded the axis. */
export function formatMonthAxisLabel(d: Date): string {
  return formatMonthLabel(d);
}
